var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mask-dialogue"},[_c('div',{staticClass:"mask",on:{"click":_vm.hideMaskVue}}),_c('div',{staticClass:"mask-container"},[_vm._t("default",null,{"id":"mask-slot"})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }